import { initialize } from "esbuild";
import { ModuleKey } from "~/modules/registry";

export interface CustomModule {
  destroy(): void;
}

export interface AsyncInit {
  init(): Promise<void>;
}

export interface SyncInit {
  init(): void;
}

export type NGSModuleMetadata = {
  name: string;
  accessor: ModuleKey;
  dependencies: ModuleKey[];
  description?: string;
  routes?: string[];
};

export abstract class NGSModule implements CustomModule {
  private readonly _metadata: NGSModuleMetadata;
  private _errors: string[] = [];

  constructor() {
    this._metadata = this.meta();
  }

  public get name(): string {
    return this._metadata.name;
  }

  public get dependencies(): ModuleKey[] {
    return this._metadata.dependencies;
  }

  public get description(): string | null {
    return this._metadata.description ?? null;
  }

  public get key(): ModuleKey {
    return this._metadata.accessor;
  }

  public get HasDescription(): boolean {
    return this.description !== null;
  }

  protected log(message: string): void {
    console.log(`[${this.name}]: ${message}`);
  }

  protected warn(message: string): void {
    console.warn(`[${this.name}]: ${message}`);
  }

  protected addError(message: string): void {
    this._errors.push(message);
  }

  public get errors(): string[] {
    return this._errors;
  }

  public get hasErrors(): boolean {
    return this._errors.length > 0;
  }

  protected abstract meta(): NGSModuleMetadata;

  abstract destroy(): void;
}
